import { INote } from "../../types/interfaces";
import AppDatabase from "../InitialiseDatabase";
export default class NoteHandler{
  DB: AppDatabase;
  constructor(){
    this.DB = new AppDatabase()
  }

  async CreateNote(title:string,desc:string,folder:string,content:string,project:string) {
    return await this.DB.notes.add({
      title,
      description: desc,
      folder, date: new Date(),content,project
    })
  }

  async EditNote(filterKey:number,updateObj:INote) {
    await this.DB.notes.update(filterKey,updateObj)
  }
  

  async FetchNotes(project:string) {
    let notes = await this.DB.notes.where("project").equals(project).toArray()
    return notes
  }

  async FetchNote(filterName: string) {
    let note = await this.DB.notes.get({title:filterName})
    return note 
  }

  async DeleteNote(filterKey:number) {
    await this.DB.notes.delete(filterKey)
  }

  // Control Folders
  async CreateFolder(title: string, colour: string,project:string) {
    const folders = await this.FetchFolders(project)
    let isMatching = false
    folders.forEach((folder) => {
      if (folder.title == title) {
        isMatching = true
      } else isMatching = false
    })
    if (!isMatching) await this.DB.notesFolder.add({title,colour,notes:[],project})
  }

  async FetchFolders(project:string) {
    let Folders = await this.DB.notesFolder.where("project").equals(project).toArray()
    // let FolderNames = Folders.map((folder) => {
    //   return folder.title
    // })
    Folders = Array.from(new Set(Folders))
    return Folders
  }

  async DeleteFolder(folderKey: number, doDeleteNotes: boolean) {
    const folder = await this.DB.notesFolder.get(folderKey)
    await this.DB.notes.where({ folder: folder?.title }).modify({
      folder:"Default"
    })
    await this.DB.notesFolder.delete(folderKey)
  }
}